<!--Management Layout-->
@if (filteredScreens) {
  <div>
    <mat-nav-list class="side-navbar">
      @for (screen of filteredScreens; track screen; let i = $index) {
        <div>
          <div [ngTemplateOutlet]="screen.children ?  childMenu : parentMenu"
            [ngTemplateOutletContext]="{screen:screen}">
          </div>
        </div>
      }
    </mat-nav-list>
    <ng-template #parentMenu let-screen="screen">
        <mat-list-item [routerLink]="screen.route" routerLinkActive="is-active" [routerLinkActiveOptions]="{exact:
        true}" (click)="onScreenSelected(screen)" mat-list-item [attr.data-testid]="screen.name" [ngStyle]="{'margin-left': '7px'}">
        {{ screen.name }}
      </mat-list-item>
    </ng-template>
    <ng-template #childMenu let-screen="screen">
      <mat-expansion-panel [class.mat-elevation-z0]="true" [expanded]="isPanelExpanded(screen)">
        <mat-expansion-panel-header>
          {{ screen.name }}
        </mat-expansion-panel-header>
        <mat-nav-list class="expandable">
          @for (nestedScreen of screen.children; track nestedScreen) {
            <mat-list-item [routerLink]="nestedScreen.route"
              routerLinkActive="is-active" [routerLinkActiveOptions]="{exact:true}"
              (click)="onScreenSelected(nestedScreen)" mat-list-item [attr.data-testid]="screen.name">
              {{ nestedScreen.name }}
            </mat-list-item>
          }
        </mat-nav-list>
      </mat-expansion-panel>
    </ng-template>
  </div>
}

<!--Reports Layout-->
@if (!filteredScreens) {
  <div>
    <mat-nav-list>
      @for (screen of screens; track screen) {
        <mat-list-item
          [attr.data-testid]="screen.name"
          mat-list-item
          [ngClass]="{ selected: screen.selected }"
          (click)="onScreenSelected(screen)"
          routerLinkActive="is-active"
          >
          {{ screen.name }}
        </mat-list-item>
      }
    </mat-nav-list>
  </div>
}
